import {OperationStateTypesEnum, ProfileEnum} from 'presentation/constants';
import {usePersonalData} from 'presentation/hooks';
import {usePostB2BBeneficiaryAuthorizationMutation} from 'presentation/mutation/usePostB2BBeneficiaryAuthorizationMutation';
import {useGetB2BBeneficiaryStatusQuery} from 'presentation/queries/useGetB2BBeneficiaryStatusQuery';
import {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

export const useBusinessAccessPermission = () => {
	const {
		accountData: {beneficiary},
		isB2BBeneficiaryAuthorized,
	} = usePersonalData();
	const {refetch: resetIsB2BBeneficiaryAuthorized} = useGetB2BBeneficiaryStatusQuery({
		userCode: beneficiary.cdUsuarioC,
	});
	const [termsCheckedState, setTermsCheckedState] = useState<boolean>(false);
	const [isCheckboxRequiredState, setIsCheckboxRequiredState] = useState<boolean>(false);

	const [operationScheduleState, setOperationScheduleState] = useState<OperationStateTypesEnum>(
		OperationStateTypesEnum.NONE,
	);

	const {state: routeState} = useLocation();
	const navigate = useNavigate();

	const AUTHORIZE_ACCESS_IS_LOADING =
		operationScheduleState === OperationStateTypesEnum.SUBMITTING;
	const AUTHORIZE_ACCESS_IS_ERROR = operationScheduleState === OperationStateTypesEnum.ERROR;
	const AUTHORIZE_ACCESS_IS_DONE = operationScheduleState === OperationStateTypesEnum.DONE;

	const handleBack = () => {
		if (routeState) {
			navigate(routeState);
			return;
		}

		navigate(ProfileEnum.PROFILE);
	};

	const resetStatesAfterSuccess = () => {
		setIsCheckboxRequiredState(false);
		setTermsCheckedState(false);
		resetIsB2BBeneficiaryAuthorized();
	};

	const {mutateAsync: postB2BBeneficiaryAuthorization} =
		usePostB2BBeneficiaryAuthorizationMutation();

	const handleAuthorizeAccess = async () => {
		if (!termsCheckedState) {
			setIsCheckboxRequiredState(true);
			return;
		}

		try {
			setOperationScheduleState(OperationStateTypesEnum.SUBMITTING);

			await postB2BBeneficiaryAuthorization({
				userCode: beneficiary.cdUsuarioC,
				enable: !isB2BBeneficiaryAuthorized,
			});

			resetStatesAfterSuccess();
			setOperationScheduleState(OperationStateTypesEnum.DONE);
			handleBack();
		} catch (error) {
			setOperationScheduleState(OperationStateTypesEnum.ERROR);
		}
	};

	return {
		termsCheckedState,
		setTermsCheckedState,
		isCheckboxRequiredState,
		AUTHORIZE_ACCESS_IS_LOADING,
		AUTHORIZE_ACCESS_IS_ERROR,
		AUTHORIZE_ACCESS_IS_DONE,
		handleBack,
		handleAuthorizeAccess,
		setOperationScheduleState,
	};
};
